import { colors } from 'Constants/Colors';

export const iconStyle = {
  background: colors.GREEN,
  borderRadius: '50%',
  color: colors.WHITE,
};

export default { iconStyle };
